import React from 'react';
import { compose, withState, setPropTypes } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import ConfirmReportShopDialog from '../molecules/ConfirmReportShopDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  },
  button: {
    width: '100%',
    marginBottom: '19px',
    fontSize: 14,
    fontWeight: 'bold'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  setPropTypes(propTypes),
  withState('openDialog', 'updateOpenDialog', false)
);

const button = enhance(
  ({
    classes,
    message,
    content,
    openDialog,
    updateOpenDialog,
    onClickAction,
    disabled,
    monthReport,
    previewImage1,
    textReport,
    validate
  }) => {
    const okAction = () => {
      updateOpenDialog(false);
      onClickAction();
    };
    return (
      <div>
        <Button
          variant="contained"
          color="primary"
          className={[classes.button]}
          onClick={() => {
            const valid = validate();
            if (valid) {
              updateOpenDialog(true);
            }
          }}
          disabled={disabled}
        >
          {content}
        </Button>
        <ConfirmReportShopDialog
          openConfirm={openDialog}
          updateOpenConfirm={updateOpenDialog}
          okAction={() => {
            okAction();
          }}
          message={message}
          monthReport={monthReport}
          previewImage1={previewImage1}
          textReport={textReport}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
